// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import SelectizeController from "./selectize_controller"
application.register("selectize", SelectizeController)

import UtilityController from "./utility_controller"
application.register("utility", UtilityController)

import TableaudebordController from "./tableaudebord_controller"
application.register("tableaudebord", TableaudebordController)

import FactureController from "./facture_controller"
application.register("facture", FactureController)

import GrilleController from "./grille_controller"
application.register("grille", GrilleController)